import classNames from 'classnames';
import { useState } from 'react';

import RoleForm from './RoleForm';

// Entry point for creating a Role group: a button that opens a modal holding the form.
// Roles have a single creation shape (no confidential variant, no writeback), so there
// is no chooser. The form is gated on showModal so it remounts — and resets — each open.
export default function CreateRoleGroup() {
  const [showModal, setShowModal] = useState(false);

  const modalClassName = classNames('modal fixed inset-0 flex items-center justify-center', {
    'modal-open': showModal,
  });

  return (
    <>
      <button className="btn btn-secondary" onClick={() => setShowModal(true)}>
        Create Role
      </button>

      <div className={modalClassName}>
        <div className="bg-base-100 rounded-lg p-5 w-full max-w-lg">
          {showModal && <RoleForm onClose={() => setShowModal(false)} />}
        </div>
      </div>
    </>
  );
}
